// @flow

import React from 'react';
import { defaultIconProps, type IconProps, IconSvgWrapper } from './base';

const AutomationIcon = (props: IconProps) => (
  <IconSvgWrapper {...props}>
    <path
      fill={props.color}
      d="M9.39599 22.812C9.22799 22.812 9.05999 22.764 8.90399 22.668C8.53199 22.44 8.38799 21.984 8.53199 21.564L10.992 14.16C11.028 14.04 10.956 13.896 10.824 13.872L4.51199 12.612C4.17599 12.54 3.91199 12.3 3.81599 11.976C3.71999 11.652 3.81599 11.292 4.05599 11.052L13.944 1.44C14.256 1.14 14.712 1.092 15.072 1.32C15.432 1.548 15.588 1.992 15.444 2.4L12.984 9.54C12.936 9.66 13.02 9.804 13.152 9.828L19.44 11.088C19.728 11.148 19.98 11.328 20.1 11.58C20.28 11.94 20.208 12.36 19.932 12.636L10.032 22.536C9.87599 22.716 9.63599 22.812 9.39599 22.812ZM6.09599 11.508L11.868 12.66C12.012 12.684 12.156 12.756 12.276 12.84C12.588 13.092 12.696 13.5 12.576 13.848L10.788 19.212C10.716 19.428 10.992 19.596 11.148 19.44L18.024 12.564C18.144 12.444 18.084 12.228 17.916 12.192L12.12 11.028C11.94 10.992 11.784 10.92 11.652 10.788C11.376 10.536 11.292 10.152 11.412 9.816L13.176 4.704C13.248 4.488 12.984 4.32 12.816 4.476L5.98799 11.136C5.86799 11.268 5.92799 11.484 6.09599 11.508Z"
    />
  </IconSvgWrapper>
);

AutomationIcon.defaultProps = defaultIconProps;

export default AutomationIcon;
